import { useTranslation } from 'react-i18next';
import { Alert, Link, ToggleSwitch } from '@lyse-as/formds-react';
import { OpenInNewIcon } from '@lyse-as/formds-react/lib/icon/common';

import { ContainerFixed } from 'app/components/container';
import { ContainerLayoutMode } from 'app/components/container/container';
import { useAppDispatch, useAppSelector } from 'app/hooks/redux-thunk';
import { ActiveCustomerLocationPage } from 'app/pages/page-wrapper';
import { updateSecurityFilter } from 'app/store/actions/network-thunks';
import { Breakpoint, Typography as T } from 'app/component-library-wave';
import { useLoadNetworkSettings } from 'app/hooks/use-network';
import { FetchStatus } from 'app/store/root-types';
import { Spinner } from 'app/components/spinner';
import { Badge } from 'app/components/badge/badge';
import styles from '../security.module.scss';

export const SecurityFilter: ActiveCustomerLocationPage = (props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const customerId = props.userContext.customerCrmId;
  const servicePointId = props.userContext.servicePointId;
  const customerHasSecurityFilter = useAppSelector((state) => state.network.data?.securityFilterEnabled === true);

  useLoadNetworkSettings({ servicePointId, customerId });

  const {
    data: networkData,
    fetchStatus,
    updateNetworkSettings: { fetchStatus: updateFetchStatus },
  } = useAppSelector((state) => state.network);

  return (
    <ContainerFixed mode={ContainerLayoutMode.Medium} className={styles.pageContainer}>
      <section>
        <div className={styles.headingWithBadge}>
          <T
            variant="headline4"
            component="h1"
            maxBreakpoint={Breakpoint.TABLET}
            bold={true}
            className={styles.pageHeading}
          >
            {t('pages.security.securityFilter.name')}
          </T>
          {fetchStatus === FetchStatus.FULFILLED && customerHasSecurityFilter ? (
            <Badge className={styles.activatedBadge}>{t('pages.security.insurance.activated')}</Badge>
          ) : (
            <Badge className={styles.disabledBadge}>{t('pages.security.insurance.disabled')}</Badge>
          )}
        </div>
        <T
          variant="formds-common-subtitle-secondary"
          component="h2"
          maxBreakpoint={Breakpoint.TABLET}
          bold={true}
          className={styles.heading}
        >
          {t('pages.security.securityFilter.whatIsItHeading')}
        </T>
        <T variant="paragraph2" component="p" maxBreakpoint={Breakpoint.MOBILE} className={styles.paragraph}>
          {t('pages.security.securityFilter.whatIsItParagraph')}
        </T>
      </section>
      <section>
        <T
          variant="formds-common-subtitle-secondary"
          component="h2"
          maxBreakpoint={Breakpoint.TABLET}
          bold={true}
          className={styles.heading}
        >
          {t('pages.security.securityFilter.howDoesItWorkHeading')}
        </T>
        <T variant="paragraph2" component="p" maxBreakpoint={Breakpoint.MOBILE} className={styles.paragraph}>
          {t('pages.security.securityFilter.howDoesItWorkParagraph')}
        </T>
      </section>
      <section>
        <Link
          href={'https://www.altibox.no/nettvern'}
          trailingIcon={<OpenInNewIcon />}
          className={styles.nettvernLink}
          target="_blank"
        >
          {t('pages.security.securityFilter.nettvernLink')}
        </Link>
        {networkData?.securityFilterEnabled !== undefined && (
          <ToggleSwitch
            title={t('pages.security.securityFilter.toggleHeading')}
            description={t('pages.security.securityFilter.toggleDescription')}
            onCheckedChange={() =>
              dispatch(updateSecurityFilter({ servicePointId, enable: !networkData?.securityFilterEnabled }))
            }
            defaultChecked={networkData?.securityFilterEnabled}
            disabled={
              fetchStatus === FetchStatus.PENDING ||
              updateFetchStatus === FetchStatus.PENDING ||
              networkData?.securityFilterEnabled === undefined
            }
          />
        )}
        {networkData?.securityFilterEnabled === undefined && fetchStatus === FetchStatus.PENDING && (
          <Spinner marginVertical={true} />
        )}
      </section>
      {networkData?.securityFilterEnabled === undefined &&
        (fetchStatus === FetchStatus.FULFILLED || fetchStatus === FetchStatus.REJECTED) && (
          <Alert scheme="warning" title={t('pages.security.securityFilter.loadingErrorMessage')} />
        )}
    </ContainerFixed>
  );
};
